import LanguageStore from "@/stores/Language"

import CacheStore from "./Cache/CacheStores"
import CommonStore from "./CommonStore"
import EventsStore from "./Dashboard/Events"
import ReturnRequestsDataStore from "./Dashboard/ReturnRequestsDataStore"
import EmailEditStore from "./EmailEdit"
import ManagementStore from "./Management/ManagementStore"
import NotificationStore from "./Notification/Notification"
import OnboardingStore from "./Onboarding/OnboardingStore"
import PlanStore from "./Plan/Plan"
import ReturnPageStore from "./ReturnPage/ReturnPageStore"
import ReturnPageSettingStore from "./ReturnPageSetting/ReturnPageSettingStore"
import SettingStore from "./Setting/Setting"
// import SubscribersStore from "./Subscribers/SubscribersStore"
import UserInfoStore from "./UserInfoStore"
import WorkflowStore from "./Workflow/WorkflowStore"

export interface IStores {
  UserInfoStore: UserInfoStore
  CommonStore: CommonStore
  EventsStore: EventsStore
  ReturnRequestsDataStore: ReturnRequestsDataStore
  ManagementStore: ManagementStore
  NotificationStore: NotificationStore
  OnboardingStore: OnboardingStore
  ReturnPageStore: ReturnPageStore
  ReturnPageSettingStore: ReturnPageSettingStore
  SettingStore: SettingStore
  EmailEditStore: EmailEditStore
  LanguageStore: LanguageStore
  PlanStore: PlanStore
  WorkflowStore: WorkflowStore
  CacheStore: CacheStore
}
/**
 * @stores 集合所有的 stores
 * @example componentStore: new ComponentStore()
 */
const stores: IStores = {
  CommonStore: new CommonStore(),
  EventsStore: new EventsStore(),
  ManagementStore: new ManagementStore(),
  UserInfoStore: new UserInfoStore(),
  ReturnRequestsDataStore: new ReturnRequestsDataStore(),
  NotificationStore: new NotificationStore(),
  OnboardingStore: new OnboardingStore(),
  ReturnPageStore: new ReturnPageStore(),
  ReturnPageSettingStore: new ReturnPageSettingStore(),
  SettingStore: new SettingStore(),
  EmailEditStore: new EmailEditStore(),
  LanguageStore: new LanguageStore(),
  PlanStore: new PlanStore(),
  WorkflowStore: new WorkflowStore(),
  CacheStore: new CacheStore(),
}

stores.ManagementStore.initGuideReaction(stores.UserInfoStore)

export default stores
